// @ts-nocheck
/* eslint-disable */
export const appClose16Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6621 3.32812L3.33841 12.6518" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round"/><path d="M3.33789 3.32812L12.6616 12.6518" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round"/></svg>`,
    name: 'close-16' as const
};